export default __webpack_public_path__ + "static/media/chair.f02c29a0.png";